import { getResponseData, type ApiClient } from "@/modules/api/apiClient.ts";
import { getPaymentReturnUrl } from "@/modules/billing/payment/urls.ts";
import type {
    PaypalIdTokenResponse,
    PaypalPaymentTokenResponse,
    PaypalSetupTokenResponse,
} from "@warrenio/api-spec/spec.oats.gen";

export async function idTokenQuery(
    apiClient: ApiClient,
    signal: AbortSignal,
    sessionId: string,
): Promise<PaypalIdTokenResponse> {
    return getResponseData(
        await apiClient.GET("/payment/paypal/id_token", {
            params: { query: { session_id: sessionId } },
            signal,
        }),
    );
}

export async function setupTokenQuery(
    apiClient: ApiClient,
    signal: AbortSignal,
    sessionId: string,
): Promise<PaypalSetupTokenResponse> {
    return getResponseData(
        await apiClient.GET("/payment/paypal/setup_token", {
            params: { query: { session_id: sessionId, return_url: getPaymentReturnUrl() } },
            signal,
        }),
    );
}

export async function paymentTokenQuery(
    apiClient: ApiClient,
    signal: AbortSignal,
    sessionId: string,
    vaultSetupToken: string,
): Promise<PaypalPaymentTokenResponse> {
    return getResponseData(
        await apiClient.GET("/payment/paypal/payment_token", {
            params: { query: { session_id: sessionId, setup_token: vaultSetupToken } },
            signal,
        }),
    );
}
